import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {useModalNotices} from "@dropDesk/presentation/pages/notices/ui/form/modals/handle_change_visible";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {NoticesEntity} from "@dropDesk/domain/entities/notices/notices.entity";
import ModalSearchUser from "@dropDesk/presentation/components/modals/modal_search_user";
import ModalSearchClient from "@dropDesk/presentation/components/modals/modal_search_client";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


const ModalsFormNotices = observer(
    ({
         onUpdate,
         notice,
         loading,
         onDeleteNotices,

     }: {
         onUpdate: (notice: NoticesEntity) => void,
         notice?: NoticesEntity,
         loading: boolean,
         onDeleteNotices: () => Promise<void>,
     }
    ) => {

        const {
            visibleModalDelete, setVisibleModalDelete
        } = useBetween(useModalNotices);

        return (
            <>

                <ModalInformation
                    open={visibleModalDelete}
                    onRequestClose={() => {
                        setVisibleModalDelete(false);
                    }}
                    textHeaderModal={'Excluir Aviso'}
                    textButton={'Excluir'}
                    onRequestSave={async () => {
                        onDeleteNotices();
                        setVisibleModalDelete(false);
                    }}
                    nameIcon={ICONS_DROPDESK.delete}
                    sizeIcon={130}
                    textInformation={`Deseja realmente excluir este aviso?`}
                    loading={loading}
                    isActionDelete={true}
                />

            </>
        )
    })
export default ModalsFormNotices;
